import { Badge, HStack, Text } from '@chakra-ui/react';
import React from 'react';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import SparkelIcon from './icon/SparkelIcon';

interface UserBadgeProps {
  username: string;
  size?: string;
}

export default function UserBadge({
  username,
  size = 'xs',
}: UserBadgeProps): React.ReactElement {
  return (
    <Badge
      textTransform={'none'}
      size={size}
      px={2}
      variant={'subtle'}
      colorScheme={'gray'}
      fontSize={size}
      borderRadius={'full'}
    >
      <HStack>
        <SparkelIcon icon={faUser} size="xs" color="inherit" />
        <Text noOfLines={1} wordBreak={'break-all'}>
          {username}
        </Text>
      </HStack>
    </Badge>
  );
}
